var _defs, _path, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.56,
    y1: 21.96,
    x2: 39.2,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 30.12,
    y1: 43.48,
    x2: 31.88,
    y2: 46.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#86c3db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5eafcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 29.67,
    y1: 42.69,
    x2: 32.33,
    y2: 47.31,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 23.12,
    y1: 43.48,
    x2: 24.88,
    y2: 46.52,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 22.67,
    y1: 42.69,
    x2: 25.33,
    y2: 47.31,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 37.12,
    y1: 43.48,
    x2: 38.88,
    y2: 46.52,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 36.67,
    y1: 42.69,
    x2: 39.33,
    y2: 47.31,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5,31.5l-.32,0a10.49,10.49,0,0,0-19.11-8,7,7,0,0,0-10.57,6,7.21,7.21,0,0,0,.1,1.14A7.5,7.5,0,0,0,18,45.5a4.19,4.19,0,0,0,.5,0v0h28a7,7,0,0,0,0-14Z",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 45,
    r: 1.25,
    fill: "none",
    strokeMiterlimit: 10,
    stroke: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.17,46.25l-1.09-.63m-2.16-1.24-1.09-.63M31,42.5v1.25m0,3.75V46.25m-1.08-.63-1.09.63m4.34-2.5-1.09.63",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    stroke: "url(#c)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "-1 -6; 1 12",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    values: "0 31 45; 360 31 45",
    dur: "9s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;1;0",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 45,
    r: 1.25,
    fill: "none",
    strokeMiterlimit: 10,
    stroke: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.17,46.25l-1.09-.63m-2.16-1.24-1.09-.63M24,42.5v1.25m0,3.75V46.25m-1.08-.63-1.09.63m4.34-2.5-1.09.63",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    stroke: "url(#e)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "1 -6; -1 12",
    begin: "-2s",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    values: "0 24 45; 360 24 45",
    dur: "9s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;1;0",
    begin: "-2s",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 45,
    r: 1.25,
    fill: "none",
    strokeMiterlimit: 10,
    stroke: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.17,46.25l-1.09-.63m-2.16-1.24-1.09-.63M38,42.5v1.25m0,3.75V46.25m-1.08-.63-1.09.63m4.34-2.5-1.09.63",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    stroke: "url(#g)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "1 -6; -1 12",
    begin: "-1s",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    additive: "sum",
    values: "0 38 45; 360 38 45",
    dur: "9s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;1;0",
    begin: "-1s",
    dur: "4s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.15e52608a8d5541c55466a6b5df8d892.svg";
export { ForwardRef as ReactComponent };